async function requestJson(path, options = {}) {
  const response = await fetch(path, {
    credentials: "include",
    headers: {
      Accept: "application/json",
      ...(options.body ? { "Content-Type": "application/json" } : {}),
    },
    ...options,
  });
  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(data.message || `Request failed (${response.status})`);
  }
  return data;
}

function buildQuery(params = {}) {
  const search = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value != null && value !== "") search.set(key, String(value));
  });
  const q = search.toString();
  return q ? `?${q}` : "";
}

export async function fetchVehicleBestValueDashboard(params = {}) {
  return requestJson(`/api/admin/mobility/vehicle-best-value${buildQuery(params)}`);
}

export async function fetchVehicleBestValueListing(listingId) {
  return requestJson(
    `/api/admin/mobility/vehicle-best-value/${encodeURIComponent(listingId)}`
  );
}

export async function recalculateListingBestValue(listingId) {
  return requestJson(
    `/api/admin/mobility/vehicle-listings/${encodeURIComponent(listingId)}/recalculate-best-value`,
    { method: "POST" }
  );
}

export async function recalculateAllBestValue(params = {}) {
  return requestJson(
    `/api/admin/mobility/vehicle-best-value/recalculate${buildQuery(params)}`,
    { method: "POST", body: JSON.stringify({ limit: params.limit }) }
  );
}
